import { create } from "zustand"

export type RoleInfo = {
    userId: string
    sdkId: string
    nickname: string | null
}

type SessionState = {
    user: RoleInfo | null
    setUser: (user: RoleInfo) => void
    logout: () => void
}

const useSessionStore = create<SessionState>((set) => ({
    user: null,
    setUser: (user) => set({ user }),
    logout: () => set({ user: null }),
}))

export const useRoleInfo = () => useSessionStore((state) => state.user)
export const useSetUser = () => useSessionStore((state) => state.setUser)
export const useLogout = () => useSessionStore((state) => state.logout)

export const setUser = (user: RoleInfo) => {
    useSessionStore.getState().setUser(user)
}

export const useRoleMeta = () => {
    const user = useRoleInfo()
    return user
        ? { channel: "kr", uid: user.userId, nickName: user.nickname }
        : null
}

export const useSessionReady = () => true
